import React, { useEffect, useRef } from 'react'
import Header from './Header/Header'
import Footer from './Footer/Footer'
import HeroWrap from './HomePageComponent/HeroWrap'
import { useLocation } from 'react-router-dom'
import OurApp from './HomePageComponent/OurApp'
import AboutUs from './HomePageComponent/AboutUs'
import CourseCategory from './HomePageComponent/CourseCategory'
import ImproveSkill from './HomePageComponent/ImproveSkill'
import ConnectWithUs from './HomePageComponent/ConnectWithUs'

import PopularMentor from './HomePageComponent/PopularMentor'
import Testimonial from './HomePageComponent/Testimonial'

import AOS from "aos";
import TutorFlow from './HomePageComponent/TutorFlow'
import { useDispatch, useSelector } from 'react-redux'
import { getHomeAboutNineSecData, getWebsiteManagementData } from '../../Redux/action/MasterAction'

import FeedbackForm from '../FeedbackForm/FeedbackForm'

const HomePage = () => {

    

    const scrollToTop = () => {
        window.scrollTo(0, 0);
    }
    const dispatch = useDispatch();

    const {

        loadingHomeAboutNineSecDataApi,
        HomeAboutNineSecDataApiData,
        HomeAboutNineSecDataApiError

    } = useSelector(state => state?.MasterReducer);

    useEffect(() => {
        dispatch(getHomeAboutNineSecData())

    }, []);





    return (
        <div>
            <>

                <FeedbackForm />
                <Header />
                <HeroWrap />
                <TutorFlow />
                <AboutUs loadingHomeAboutNineSecDataApi={loadingHomeAboutNineSecDataApi} HomeAboutNineSecDataApiData={HomeAboutNineSecDataApiData} HomeAboutNineSecDataApiError={HomeAboutNineSecDataApiError} />
                <PopularMentor />
                <CourseCategory />
                 <ImproveSkill />
                <ConnectWithUs />
                <Testimonial />
                <OurApp loadingHomeAboutNineSecDataApi={loadingHomeAboutNineSecDataApi} HomeAboutNineSecDataApiData={HomeAboutNineSecDataApiData} HomeAboutNineSecDataApiError={HomeAboutNineSecDataApiError} />
                <Footer />
                <a onClick={scrollToTop} className="back-to-top open">
                    <i className="las la-arrow-up" />
                </a>

            </>

        </div>
    )
}

export default HomePage